class ForgotPasswordController {
  /*@ngInject*/
  constructor(Auth, User, $scope,  $rootScope,  $state, $location, $translate, MobileAppService, ngToast, $stateParams) {
    this.Auth = Auth
    this.User = User
    this.$rootScope =  $rootScope;
    this.$scope = $scope;
    this.$state = $state
    this.$location = $location;
    this.ngToast = ngToast;
    this.MobileAppService = MobileAppService;
    this.$stateParams = $stateParams;
    this.isLoggedIn = false;
    if (Auth.isAuthenticated()) {
      this.$state.go('home')
    }
    this.$translate = $translate;
    this.isForgotLoading = false;
    this.name = 'forgotPassword';
    this.userCredentials = {
      email: '',
    }

    this.resetCredentials = {
      email: '',
      code: '',
      password: '',
      cpassword: ''
    }

    this.error = ''
    this.successMsg = '';
    this.appData = '';

    this.togglePassword = {
      pass: false,
      cpass: false
    }

    this.model = {
      passwordPolicy: null,
      showPasswordPolicy: false
    };
  }

  $onInit() {
    this.isForceChangePassword  = this.$stateParams.isForceChangedPassword;
  }

  submitForgotPWD(form) {
    if (this.isForgotLoading) return;
    this.error = '';
    this.successMsg = '';
    if (form.$valid) {
      this.isForgotLoading = true;
      this.Auth.isUserEmailExist(this.userCredentials).then((data) => {
        if (data.status) {
          this.name = 'resetPassword'
          this.resetCredentials.email = this.userCredentials.email;
          this.successMsg =  this.$translate.instant('login.reset_password_request_code');
          if (data && data.errors) {
            this.model.passwordPolicy = { ...data };
          }
        } else {
          this.error = 'No user match with provided email address';
        }
        this.isForgotLoading = false;

      }, error => {
        console.log(error)
        this.isForgotLoading = false;
      }, () => {
        setTimeout(() => {
          if (this.successMsg) { this.successMsg = '' }
        }, 3000)
      })
    } else {
      if (form.$error.required) {
        this.error = this.$translate.instant('login.email_required');
      } else if (form.$error.email && form.$error.email.length) {
        this.error = this.$translate.instant('login.invalid_email_required');
      }
    }
  }

  resetPassword(form) {
    if (this.isResetLoading) return;
    this.error = '';
    this.successMsg = '';

    if (form.$valid) {
      this.isResetLoading = true;
      this.Auth.resetUserPassword(this.resetCredentials)
        .then((data) => {
          if (data.status && data.message !== 'failed') {
            this.successMsg = this.$translate.instant('login.reset_request_success');
            setTimeout(() => {
              this.$state.go('login');
            }, 2500)
          }
          else if (data && data.message == 'failed') {
            this.model.passwordPolicy = data;
          }
          this.isResetLoading = false;
        }, error => {
          this.isResetLoading = false;
          this.error = error.data.message;
        })
    } else {
      if (form.$error.required) {
        this.error = this.$translate.instant('login.email_required');
      } else if (form.$error.email && form.$error.email.length) {
        this.error = this.$translate.instant('login.invalid_email_required');
      }
    }
  }

  showPassword(control) {
    this.togglePassword[control] = !this.togglePassword[control]
  }

  checkPasswordPolicy() {
    this.successMsg = '';
    this.model.passwordPolicy.isCurrentPassSameAsPrevious = false;
    if (!this.model.passwordPolicy || !this.model.passwordPolicy.errors) return;
    const pwd = this.resetCredentials.password || "";
    if (!pwd) {
      this.model.passwordPolicy.filterErrors = [];
      return;
    }
    const unmet = [];
    this.model.passwordPolicy.errors.forEach(rule => {
      let isValid = true;
      switch (rule.validation) {
        case "min":
          isValid = pwd.length >= rule.arguments;
          break;
        case "uppercase":
          isValid = (pwd.match(/[A-Z]/g) || []).length >= rule.arguments;
          break;
        case "lowercase":
          isValid = (pwd.match(/[a-z]/g) || []).length >= rule.arguments;
          break;
        case "digits":
          isValid = (pwd.match(/[0-9]/g) || []).length >= rule.arguments;
          break;
        case "symbols":
          isValid = (pwd.match(/[^A-Za-z0-9]/g) || []).length >= rule.arguments;
          break;
      }
      if (!isValid) unmet.push(rule);
    });
    this.model.passwordPolicy.filterErrors = unmet;
  }
}

export default ForgotPasswordController;



// WEBPACK FOOTER //
// ./client/app/components/forgot_password/forgot_password.controller.js